import { ChangeDetectionStrategy, Component, EventEmitter, Injector, Input, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessor } from '../../value-accessor/value-accessor';
import { SeraDropdownOption } from '../../models/SeraDropdownOption';

@Component({
    selector: 'sera-multiselect',
    templateUrl: './sera-multiselect.component.html',
    styleUrls: ['./sera-multiselect.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SeraMultiselectComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SeraMultiselectComponent extends ValueAccessor<any> {
    @Input()
    label: string = 'MultiSelect';

    @Input()
    virtualScroll: boolean = true;

    @Input()
    isDisabled: boolean = false;

    @Input()
    required: boolean = false;

    @Input()
    itemSize: number = 30;

    @Input()
    options: SeraDropdownOption[] = [];

    @Input()
    tooltip: any = null;

    @Input()
    filter: boolean = true;

    @Input()
    inputId: string = 'multiselect';

    @Input()
    showClear: boolean = true;

    @Input()
    style: {} = { width: '100%' };

    @Input()
    readOnly: boolean = false;

    @Input()
    styleClass: string = '';

    @Input()
    placeholder: string | undefined;

    @Output() selectionChanged = new EventEmitter<any>();

    @Output() clearSelection = new EventEmitter<any>();

    @Output() closeSelection = new EventEmitter<any>();

    constructor(injector: Injector) {
        super(injector);
    }

    onPanelShow(): void {
        if (this.value) {
            this.reorderOptions(this.value);
        }
    }

    reorderOptions(value: any): void {
        const selectedKeys = Array.isArray(value) ? value : [value];
        const selectedItems = this.options.filter(option => selectedKeys.includes(option.key));
        const otherItems = this.options.filter(option => !selectedKeys.includes(option.key));
        this.options = [...selectedItems, ...otherItems];
    }
}
